import { getRoles } from '../../../apis/rbac';

export default {
  data() {
    return {
      roleInfo: {},
    };
  },
  async created() {
    await this.getRolesInfo();
  },
  methods: {
    async getRolesInfo() {
      const roles = await getRoles();
      this.roleInfo = roles.reduce((result, item) =>
        ({ ...result, [item.role_name]: item.role_id }),
      {});
      return this.roleInfo;
    },
  },
};
